import servicesTemplate from './services.html';
import './services.scss';

export default angular
  .module('main.locations.edit.tabs.services', [])

  .directive('editLocationServicesTab', () => {
    return {
      restrict: 'E',
      template: servicesTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   utils,
                   $filter,
                   $translate,
                   config,
                   ToastsService,
                   EditLocationDataProvider,
                   PermissionsService,
                   I18nService) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        const $t = $filter('translate');
        const answerStatuses = config.getConfigByKey('questionAnswerStatuses');
        const serviceStatuses = config.getConfigByKey('serviceStatuses');
        const locale = I18nService.getLocale()?.code || 'en';

        /**
         * Supported response types for answering questions
         * 2 - Dropdown
         * 7 - Slider (range)
         * 9 - Date picker (datetime)
         * 10 - Multi-select
         */
        const availableResponseTypes = [2, 7, 9, 10];

        $scope.isServiceAdmin = PermissionsService.isServiceAdmin();
        $scope.answerStatuses = answerStatuses.filter(el => !el.hidden);
        $scope.currentLocale = $translate.proposedLanguage() || $translate.use() || 'en';

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
          onEditQuestionButtonClick: onEditQuestionButtonClick,
          filterByAnswerStatus: filterByAnswerStatus,
          isSomethingFound: isSomethingFound,
          updateAnswer: updateAnswer,
          availableToAnswer: availableToAnswer
        });

        // Narratives datepicker options
        $scope.questionDatePickerOptions = {
          language: locale,
          position: 'bottom left',
          view: 'days',
          minView: 'days',
          autoClose: true,
          // maxDate: new Date(),
          clearButton: true,
          dateFormat: 'm/dd/yyyy',
          timepicker: true,
          timeFormat: 'hh:mm AA',
        };

        init();

        function init() {
          initWatchers();
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.locationQuestionsResource.init(),
            $scope.dataProvider.locationServicesStateResource.init(),
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });

          $('#service-form').form({
            on: 'blur',
            inline: true,
            revalidate: true,
            keyboardShortcuts: false,
            fields: {
              'sliderValue': {
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.empty')
                  },
                  {
                    type: 'integer',
                    prompt: $t('prompt.params.integer')
                  }
                ]
              },
              'sliderValueSimple': {
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.empty')
                  },
                  {
                    type: 'integer',
                    prompt: $t('prompt.params.integer')
                  }
                ]
              }
            }
          });
        }

        function initWatchers() {
          $scope.$watch('dataProvider.locationServicesStateResource.value', (newValue, oldValue) => {
            if (oldValue) {
              return $q.when(
                $scope.dataProvider.locationQuestionsResource.init(true)
                  .then(() => initViewModel(), (err) => $q.reject(err))
              );
            }
          });

          // Remove modal
          $scope.$on('$destroy', () => {
            $('#answer-modal').remove();
          });
        }

        function initViewModel() {
          let questions = angular.copy($scope.dataProvider.locationQuestionsResource.value);
          let services = angular.copy($scope.dataProvider.locationServicesStateResource.value);
          $scope.location = angular.copy($scope.dataProvider.locationResource.value);

          if (questions.length === 0) {
            $scope.collections = [];
            return;
          }

          $scope.collections = [
            {
              name: $t('questions.defaultCollection'),
              weight: 500,
              questions: questions.filter(q => !q.collection)
            }
          ];

          questions.forEach((question) => {
            question.answer = fixAnswer(question);
            question.answerDesc = getAnswerDesc(question);
            question.color = getQuestionColor(question.status);

            // Group questions by collection
            if (question.collection) {
              // Find existing collection and push question there
              let existingCollection = $scope.collections.find(el => el.name === question.collection.name);
              if (existingCollection) {
                existingCollection.questions.push(question);
              } else {
                // Add new collection and push question into it
                let newCollection = angular.copy(question.collection);
                newCollection.questions = [];
                $scope.collections.push(newCollection);
                $scope.collections[$scope.collections.length - 1].questions.push(question);
              }
            }
          });

          $scope.collections = $filter('orderBy')($scope.collections, 'weight');

          // Get additional data from 'services' location state
          services.forEach(s => {
            let modifyObj;
            let modifyObjType;
            if (s['question_id']) {
              modifyObj = questions.find(q => q.key === s['question_id']);
              modifyObjType = 'question';
            } else if (s['collection_id']) {
              modifyObj = $scope.collections.find(c => c.name === s['collection_id']);
              modifyObjType = 'collection';
            }

            if (modifyObj) {
              modifyObj.serviceTitle = s.title;
              modifyObj.serviceComment = s.comment;
              modifyObj.percent = s.percent;

              let statusDetails = getCurrentStatusDetails(s.status);
              if (statusDetails) {
                modifyObj.status = s.status;
                modifyObj.statusColor = statusDetails.statusColor;
                modifyObj.statusDesc = statusDetails.statusDesc;
                modifyObj.statusText = s['status_text'];
              }

              // Update related question with service data
              if (s['display_info'] && s['display_info']['home_area']) {
                let questionKey = s['display_info']['home_area']['display_area_map'] ? s['display_info']['home_area']['question_key'] : undefined;

                if (modifyObjType === 'collection') {
                  let questionIndex = modifyObj.questions.findIndex(q => q.key === questionKey);
                  if (questionIndex !== -1 && !!$scope.location.latitude && !!$scope.location.longitude) {
                    modifyObj.questions[questionIndex].displayAreaMap = true;
                  }
                } else {
                  modifyObj.displayAreaMap = true;
                }
              }
            }
          });
        }

        function filterByAnswerStatus(item) {
          if (!$scope.selectedAnswerStatus) {
            return true;
          }
          return item.answerStatus === $scope.selectedAnswerStatus || item.status === $scope.selectedAnswerStatus;
        }

        function isSomethingFound() {
          if (!$scope.selectedAnswerStatus && !$scope.searchVal) {
            return true;
          }

          return $scope.collections.some(cl => {
            let questions = cl.questions;
            if (!questions) {
              return false;
            }
            questions = $filter('filter')(questions, filterByAnswerStatus);
            questions = $filter('filter')(questions, { question: $scope.searchVal });

            return questions.length > 0;
          });
        }

        function onEditQuestionButtonClick(question) {
          // Test supported response types
          if ($scope.loading || !availableToAnswer(question)) {
            return;
          }

          let fieldNames = [];
          let selectedQuestion = angular.copy(question);

          // Parse dropdown value
          if (selectedQuestion.responseType === 2) {
            let selectedOption = selectedQuestion.responseOptions?.find(el => parseInt(el.id) === parseInt(selectedQuestion.answer));
            selectedQuestion.answer = selectedOption ? selectedOption.id : undefined;
            $scope.selectedAnswer = selectedOption;

          // Parse slider value
          } else if (selectedQuestion.responseType === 7) {
            $scope.sliderMin = parseInt(selectedQuestion.slider?.min || '0');
            $scope.sliderMax = parseInt(selectedQuestion.slider?.max || '100');
            $scope.sliderStep = parseInt(selectedQuestion.slider?.inc || '1');
            $scope.sliderUnits = selectedQuestion.slider?.unitsDesc;

            fieldNames = ['sliderValue', 'sliderValueSimple'];
            selectedQuestion = {
              ...selectedQuestion,
              answerValue: parseFloat(selectedQuestion.answer),
            };

          // Parse date value
          } else if (selectedQuestion.responseType === 9) {
            let answerDate = selectedQuestion.answer ? new Date(selectedQuestion.answer) : null;
            $scope.selectedAnswer = answerDate;

            if (selectedQuestion.displayType === 0) {
              $scope.questionDatePickerOptions.timepicker = true;
            } else {
              $scope.questionDatePickerOptions.timepicker = false;
            }
          }

          $scope.selectedQuestion = selectedQuestion;

          $('#answer-modal').modal({
            autofocus: false,
            closable: false,
            onShow: () => {
              clearFormErrors();
            },
            onApprove: () => {
              // Validate service form
              if (fieldNames && fieldNames.length > 0) {
                triggerFormValidation();
                fieldNames.forEach(fieldName => {
                  if (!$('#service-form').form('is valid', fieldName)) {
                    return false;
                  }
                });
              }

              return updateAnswer($scope.selectedQuestion);
            },
          }).modal('show');
        }

        /**
         * Update question answer
         * @return {Promise}
         */
        function updateAnswer(question) {
          if ($scope.loading) {
            return;
          }

          // Parse range (slider) value
          if (question.responseType === 7) {
            question.answer = question.answerValue.toString();
          }

          // Parse date value
          if (question.responseType === 9) {
            question.answer = $scope.selectedAnswer ? $scope.selectedAnswer.toISOString() : null;
          }

          $scope.loading = true;
          $scope.dataProvider.updateQuestionAnswer(question)
            .then(() => {
              // Show toast only for singe-toggle question
              if (question.responseType === 1 && question.displayType === 2) {
                ToastsService.success($t('locations.edit.services.successMsg'));
              }
              $scope.selectedQuestion = undefined;
              $scope.loading = false;
              initViewModel();
            }, (err) => {
              utils.handleApiError(err);
              $scope.selectedQuestion = undefined;
              $scope.loading = false;
            });
        }

        /**
         * Returns color from response types
         * @param {number} status
         * @return {string}
         */
        function getQuestionColor(status) {
          let element = $scope.answerStatuses.find(el => el.id === status);
          return element && element.color ? element.color + '-mark' : 'grey-mark';
        }

        /**
         * Enrich service details with color and name
         * for service definition (object from location states 'services')
         * @param {number} status
         * @return {Object}
         */
        function getCurrentStatusDetails(status) {
          let result = {};
          if (status !== undefined) {
            let currentStatus = serviceStatuses.find(e => e.id === status);
            result.statusColor = currentStatus?.color || 'grey';
            result.statusDesc = currentStatus.name ? $t(currentStatus.name) : $t('questions.unknownStatus');
          }
          return result;
        }

        /**
         * Use current or default answer
         * @param question
         * @return {string|boolean|undefined}
         */
        function fixAnswer(question) {
          if (!question) {
            return undefined;
          }

          let answer = question.answer ?? question.defaultAnswer;
          if (question.responseType === 1) { // Fix boolean answer
            answer = (answer === 'true' || answer === '1' || answer === true || answer === 1) ? true : false;
            return answer;
          } else if (question.responseType === 2 && question.responseOptions) { // Fix answer with options
            let selectedOption = question.responseOptions.find(option => option.id === parseInt(answer));
            return selectedOption?.id ?? answer;
          }

          return answer;
        }

        function getAnswerDesc(question) {
          if (!question) {
            return undefined;
          }

          let answer = question.answer ?? question.defaultAnswer;

          // Boolean answer
          if (question.responseType === 1) {
            answer = (answer === 'true' || answer === '1' || answer === true || answer === 1) ? true : false;
            return answer;

          // Answer with options
          } else if (question.responseType === 2 && question.responseOptions) {
            let selectedOption = question.responseOptions.find(option => option.id === parseInt(answer));
            return selectedOption?.text || answer;

          // Range answer
          } else if (question.responseType === 7) {
            return (answer != null && question.slider?.unitsDesc != null)
              ? `${answer} ${question.slider?.unitsDesc}`
              : answer;
          }

          return answer;
        }

        function triggerFormValidation() {
          if (!!$scope.selectedQuestion) {
            $('#service-form').form('validate form');
          }
        }

        function clearFormErrors() {
          $('#service-form .field.error').removeClass('error');
          $('#service-form .ui.basic.red.pointing').remove();
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'dashboard';
        }

        /**
         * Check if question available for answer
         * @param question
         * @return {boolean}
         */
        function availableToAnswer(question) {
          if (!question || !question.editable) {
            return false;
          }
          return availableResponseTypes.some(type => question.responseType === type);
        }
      }
    };
  })
  .name;
